/**
 * The entry drawer's width rules: 1024 by default, 640 at the least, and at
 * most the window less a 64px strip of backdrop (click it to close). A drag
 * that ends within 24px of the default or the widest lands on it.
 */
export const DRAWER_DEFAULT_WIDTH = 1024;
export const DRAWER_MIN_WIDTH = 640;
const BACKDROP_STRIP = 64;
const SNAP_DISTANCE = 24;

/** The widest the drawer may be in a window this wide. */
export const drawerMaxWidth = (viewport: number): number =>
  Math.max(DRAWER_MIN_WIDTH, viewport - BACKDROP_STRIP);

export const clampDrawerWidth = (width: number, viewport: number): number =>
  Math.round(
    Math.min(drawerMaxWidth(viewport), Math.max(DRAWER_MIN_WIDTH, width))
  );

/** The default or the widest, when within reach of `width`; else `width`. */
export const snapDrawerWidth = (width: number, viewport: number): number =>
  [DRAWER_DEFAULT_WIDTH, drawerMaxWidth(viewport)].find(
    (s) => Math.abs(s - width) <= SNAP_DISTANCE
  ) ?? width;
